var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dms-select',{attrs:{"span":16,"select-list":_vm.dropdownList.PovVaria,"value":_vm.PovVariaList,"multiple":"","label-key":"Zarazeni"},on:{"update:value":function($event){_vm.PovVariaList=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }